import { FC, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { ModelLayer, modelLayers } from '@dbt-labs/dbt-dag';
import { DropdownButton, DropdownOption } from '@dbt-labs/sourdough';

import { toTitleCase } from '@/util/string';

export type ModelingLayerFilterDropdownProps = {};

export const MODELING_LAYER_PARAM = 'modelingLayer';

export const ModelingLayerFilterDropdown: FC<ModelingLayerFilterDropdownProps> = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const options = useMemo(
    () => [
      { label: 'All', value: 'all' },
      ...modelLayers.map((l): DropdownOption => ({ label: toTitleCase(l), value: l })),
    ],
    [],
  );

  const defaultOption = useMemo((): DropdownOption => {
    const qsValue = searchParams.get(MODELING_LAYER_PARAM) as ModelLayer | undefined;
    return options.find((o) => o.value === qsValue) || options[0];
  }, [searchParams, options]);

  return (
    <DropdownButton
      options={options}
      name={'Modeling Layer'}
      className="text-nowrap text-fgMain"
      listClassName="z-50"
      defaultOption={defaultOption}
      trackingId="explorer-modeling-layer-filter"
      onChange={({ value }) => {
        if (typeof value !== 'string') return;
        if (value === 'all') {
          setSearchParams((p) => {
            p.delete(MODELING_LAYER_PARAM);
            return p;
          });
        } else {
          setSearchParams((p) => {
            p.set(MODELING_LAYER_PARAM, value);
            return p;
          });
        }
      }}
    />
  );
};
